import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    ref: "btn",
    class: _normalizeClass(
      `flex outline-none items-center justify-center UpWntaM3dyButton__btn-${$props.type} UpWntaM3dyButton__${$props.size}-size opacity-80 hover:opacity-100 transition-all`
    )
  }, _toDisplayString($props.content), 3))
}